import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { createKitchen } from "../../../redux/actions/kitchenActions";
import { useLanguage } from "../../../context/LanguageContext";

const SectionJIECMonitoring = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const dispatch = useDispatch();
  const { t } = useLanguage();

  const [form, setForm] = useState({
    j1: "", // YES / NO
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));

    if (errors[name]) setErrors(prev => ({ ...prev, [name]: "" }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!form.j1) newErrors.j1 = t.global.err_a1;
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = async () => {
    if (!validateForm()) return;

    try {
      // Map YES/NO to 1/2
      const j1Int = form.j1 === t.global.yes ? 1 : 2;

      // Construct payload for API
      const payload = {
        district_id: state?.districtId || 1,
        municipality_id: state?.municipalityId || 1,
        ward_id: state?.wardId || 5,
        area_id: state?.areaId || 7,
        canteen_type_id: state?.canteenTypeId || 2,
        latitude: state?.latitude || "22.476200",
        longitude: state?.longitude || "88.376984",
        current_section: "iec",
        iec_mon_J1: j1Int,
        reporting_date: new Date().toISOString().split("T")[0],
      };

      // Dispatch the Redux action
      await dispatch(createKitchen(payload));

      // Save locally as well
      const surveyData = JSON.parse(localStorage.getItem("surveyData") || "{}");
      surveyData.sectionJ = { j1: j1Int };
      localStorage.setItem("surveyData", JSON.stringify(surveyData));

      const completedSections = JSON.parse(localStorage.getItem("completedSections") || "{}");
      completedSections.j = true;
      localStorage.setItem("completedSections", JSON.stringify(completedSections));

      // alert(t.global.submit_section_j);

      // Navigate back
      navigate("/survey/sections", { state });

    } catch (err) {
      console.error("Error saving Section J:", err);
      alert(t.global.alert_server_error);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 p-4">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white rounded-xl shadow p-6">
          <div className="flex items-center justify-between mb-6">
            <div>
              <h2 className="text-2xl font-bold text-gray-800">{t.modules.kitchen.sections.J.title}</h2>
              <p className="text-gray-600">{t.modules.kitchen.sections.J.subtitle || "Information, education, communication and monitoring"}</p>
            </div>
            <div className="text-sm bg-orange-100 text-orange-800 px-3 py-1 rounded-full">
              {state?.canteenId ? `${t.global.canteen_id_label} ${state.canteenId}` : 
               state?.kioskId ? `${t.global.canteen_id_label} ${state.kioskId}` : t.global.na}
            </div>
          </div>

          <div className="space-y-6">
            <div className="border rounded-lg p-4">
              <label className="block font-medium mb-3">
                J.1 {t.modules.kitchen.sections.J.questions.posters} <span className="text-red-500">*</span>
              </label>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                {[t.global.yes, t.global.no].map(option => (
                  <label 
                    key={option} 
                    className={`flex items-center p-3 border rounded cursor-pointer ${form.j1 === option ? 'bg-blue-50 border-blue-300' : ''} ${errors.j1 ? 'border-red-300' : ''}`}
                  >
                    <input
                      type="radio"
                      name="j1"
                      value={option}
                      checked={form.j1 === option}
                      onChange={handleChange}
                      className="mr-3 h-5 w-5"
                    />
                    <span className="text-lg">{option}</span>
                  </label>
                ))}
              </div>
              {errors.j1 && <p className="text-red-500 text-sm mt-2">{errors.j1}</p>}
            </div>

            <div className="flex justify-between pt-6 border-t">
              <button
                onClick={() => navigate("/survey/sections", { state })}
                className="px-6 py-3 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition"
              >
                {t.global.back_to_sections}
              </button>
              <button
                onClick={handleSave}
                className="px-6 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 transition"
              >
                {t.global.submit_section_j || "Save Section J"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectionJIECMonitoring;